const convertUniqueUsersResult = (result) => ({
  uniqueUsers: result.rows[0].users,
});

export default convertUniqueUsersResult;
